/*
 *
 * File JS per la Products
 *
 */

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroPage from "components/hero-page/hero-page";
import blockText from 'components/block-text/block-text';
import pagination from "components/pagination/pagination";
import blockProducts from "components/block-products/block-products";
import cardProduct from 'components/card-product/card-product';

// //--------------------------------------------------------------------//

// // IMPORT STILE SPECIFICO PAGINA
// //--------------------------------------------------------------------//

import "./page-products.scss";

// //--------------------------------------------------------------------//

// // INIT COMPONENTI
// //--------------------------------------------------------------------//

blockProducts();


// //--------------------------------------------------------------------//
